import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import _ from 'lodash';
import React, { useCallback, useContext, useState, useRef } from "react";
import cx from 'classnames'
import { Flex } from '@jutro/layout'
import { Chevron, Icon } from '@jutro/components';
import { TranslatorContext } from "@jutro/locale";
import metadata from './TWIABuildingAdditionalInterestsAccordion.metadata.json5'
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import messages from './TWIABuildingAdditionalInterestsAccordion.messages.js';

function TWIABuildingAdditionalInterestsAccordion(props) {
    const { handleEditLinkClick, wizardStep, isConfirmationStep, submissionVM, buildingId} = props;
    const translator = useContext(TranslatorContext);
    const [additionalInterest, setAdditionalInterest] = useState([]);
    const additionalInterestData = useRef(additionalInterest);


    additionalInterestData.current = _.filter(submissionVM?.baseData?.policyContactDetails_TWIA?.value,
        pcd => pcd.policyContactRoles[0].subtype === 'PolicyAddlInterest' &&
            pcd.policyContactRoles[0]?.policyAdditionalInterest?.cpAdditionalInterestDetails_TWIA[0]?.buildingId === buildingId);

    const formatInterestType = (type) => {

        switch (type) {
            case 'CONSALE': return translator(messages.contractofSale);
            case 'LOSSP': return translator(messages.lossPayee);
            case 'MORTGAGEE': return translator(messages.mortgagee);
            default: return type;
        }
    }

    const getName = (item) => item.subtype === 'Person' ? item.firstName + " " + item.lastName : item.contactName;

    const getInterestType = (item) => {
        if (!item && !item.policyContactRoles[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA[0].type) {
            return undefined;
        }

        return formatInterestType(item.policyContactRoles[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA[0].type);
    }

    const getLoanNumber = (item) => item.policyContactRoles[0].policyAdditionalInterest.cpAdditionalInterestDetails_TWIA[0].contractNumber;

    const getAdditionalInterestSubHeading = useCallback(() => {

        if (additionalInterestData.current.length > 0) {
            return "Yes"
        }

        return "No"
    }, [])

    const additionalInterestsHeader = useCallback((isOpen) => {
        return (
            <Flex justifyContent="between" className={styles.fullWidth}>
                <Icon icon="gw-additional-interests" id="addInterestCheck" size="medium" />
                <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.additionalInterestsHeading)}</div>
                <div className={cx(styles.heading, styles.flexOneThird)}>{getAdditionalInterestSubHeading()}</div>
                <Chevron className={styles.chevronMargin} isOpen={isOpen} />
            </Flex>
        )
    }, [])

    const editAdditionalInterest = useCallback(() => {
        if (wizardStep === -1) {
            handleEditLinkClick(4, false);
        } else {
            handleEditLinkClick(4);
        }
    }, [])

    const overrideProps = {
        additionalInterestTable: {
            data: additionalInterestData?.current
        },
        editAdditionalInterestLink: {
            visible: !isConfirmationStep
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            additionalInterestsHeader,
            editAdditionalInterest,
            getName,
            getInterestType,
            getLoanNumber,
        },
        resolveClassNameMap: styles
    }

    return (
        <ViewModelForm 
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TWIABuildingAdditionalInterestsAccordion
